if (!customElements.get("product-info")) {
  function formatPdpMoney(cents, moneyFormat) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney)
      return Shopify.formatMoney(cents, moneyFormat);
    return (
      "$" +
      (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
    );
  }

  function applyPdpDynamicUnitPrice(wrap, totalEl, originalEl) {
    const moneyFormat =
      wrap.getAttribute("data-money-format") || "${{amount}}";
    const unit = parseInt(wrap.getAttribute("data-unit-price"), 10) || 0;
    const compareAt =
      parseInt(wrap.getAttribute("data-compare-at-price"), 10) || 0;
    const hasDiscount = compareAt > unit;
    totalEl.textContent = formatPdpMoney(unit, moneyFormat);
    totalEl.classList.toggle(
      "pdp-dynamic-price__total--discount",
      hasDiscount,
    );
    if (originalEl) {
      if (hasDiscount) {
        originalEl.textContent = formatPdpMoney(compareAt, moneyFormat);
        originalEl.classList.remove("pdp-dynamic-price__original--hidden");
      } else {
        originalEl.textContent = "";
        originalEl.classList.add("pdp-dynamic-price__original--hidden");
      }
    }
  }

  function findDiscountKitVolumeTable(root) {
    return (
      root.querySelector("volume-table.dk-volume-table-component") ||
      root.querySelector(".dk-volume-table-component")
    );
  }

  function isDkVolumeTableElementVisible(el, root) {
    if (!el || !(el instanceof Element)) return false;
    if (el.hidden || el.getAttribute("aria-hidden") === "true") return false;
    let node = el;
    while (node && node !== root) {
      const s = window.getComputedStyle(node);
      if (
        s.display === "none" ||
        s.visibility === "hidden" ||
        s.opacity === "0"
      ) {
        return false;
      }
      node = node.parentElement;
    }
    const rect = el.getBoundingClientRect();
    return rect.width >= 1 || rect.height >= 1;
  }

  /** True while Buy Now add-to-cart is in progress; variant updates must not clobber UI. */
  function isBuyNowButtonInFlight(button) {
    if (!button) return false;
    if (button.getAttribute("data-buy-now-loading") === "true") return true;
    const dataLoading = button.getAttribute("data-loading");
    if (dataLoading !== null && dataLoading !== "false") return true;
    if (button.getAttribute("aria-busy") === "true") return true;
    if (button.classList.contains("loading")) return true;
    return false;
  }

  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pdpVariantChangeUnsubscriber = undefined;
      volumeDiscountsKitObserver = null;
      volumeDiscountsLinkSyncTimer = null;
      volumeDiscountsKitVariantUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.initQuantityHandlers();
        this.initDownloadItems();
        this.initLicenceModal();
        this.initPdpDynamicPrice();
        this.initVolumeDiscountsLinkDiscountKitSync();
        this.pdpVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.updatePdpPriceOnVariantChange.bind(this),
        );
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true }),
        );
      }

      /**
       * Licence link modal (Features accordion): opens .modal-link / [data-licence-modal]
       * in an overlay. Same-origin URLs are fetched and injected; others use iframe.
       */
      initLicenceModal() {
        if (window.__licenceModalListenersAdded) return;
        window.__licenceModalListenersAdded = true;

        const origin = window.location.origin;

        function isSameOrigin(href) {
          try {
            return new URL(href, window.location.href).origin === origin;
          } catch (e) {
            return false;
          }
        }

        function clearElement(el) {
          if (!el) return;
          if (el.replaceChildren) el.replaceChildren();
          else while (el.firstChild) el.removeChild(el.firstChild);
        }

        function openModal(modal, url) {
          if (!modal) return;
          const iframe = modal.querySelector("[data-licence-iframe]");
          const fetchedEl = modal.querySelector("[data-licence-fetched]");
          if (iframe) iframe.src = "about:blank";
          if (fetchedEl) {
            clearElement(fetchedEl);
            fetchedEl.setAttribute("hidden", "");
          }

          if (isSameOrigin(url)) {
            if (iframe) iframe.style.display = "none";
            if (fetchedEl) {
              fetchedEl.removeAttribute("hidden");
              fetchedEl.style.display = "block";
              const loadingP = document.createElement("p");
              loadingP.className = "licence-modal__loading";
              loadingP.textContent = "Loading…";
              fetchedEl.appendChild(loadingP);
              fetch(url, { credentials: "same-origin" })
                .then((r) => r.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, "text/html");
                  const main = doc.querySelector("#MainContent");
                  const source = main || doc.body;
                  const wrap = document.createElement("div");
                  wrap.className = "licence-modal__fetched-inner";
                  if (source) {
                    for (let i = 0; i < source.childNodes.length; i++) {
                      wrap.appendChild(
                        document.importNode(source.childNodes[i], true),
                      );
                    }
                  }
                  clearElement(fetchedEl);
                  fetchedEl.appendChild(wrap);
                })
                .catch(() => {
                  clearElement(fetchedEl);
                  const errP = document.createElement("p");
                  errP.className = "licence-modal__error";
                  errP.textContent = "Content could not be loaded. ";
                  const errLink = document.createElement("a");
                  errLink.href = url;
                  errLink.target = "_blank";
                  errLink.rel = "noopener";
                  errLink.textContent = "Open in new tab";
                  errP.appendChild(errLink);
                  errP.appendChild(document.createTextNode("."));
                  fetchedEl.appendChild(errP);
                });
            }
          } else {
            if (fetchedEl) fetchedEl.setAttribute("hidden", "");
            if (iframe) {
              iframe.style.display = "block";
              iframe.src = url;
            }
          }

          modal.removeAttribute("hidden");
          document.body.style.overflow = "hidden";
          modal.querySelector("[role='dialog']")?.focus();
        }

        function closeModal(modal) {
          const openModalEl =
            modal || document.querySelector(".licence-modal:not([hidden])");
          if (!openModalEl) return;
          const iframe = openModalEl.querySelector("[data-licence-iframe]");
          const fetchedEl = openModalEl.querySelector("[data-licence-fetched]");
          openModalEl.setAttribute("hidden", "");
          document.body.style.overflow = "";
          if (iframe) {
            iframe.src = "about:blank";
            iframe.style.display = "block";
          }
          if (fetchedEl) {
            clearElement(fetchedEl);
            fetchedEl.setAttribute("hidden", "");
          }
        }

        document.addEventListener("click", (e) => {
          const link = e.target.closest("a.modal-link, a[data-licence-modal]");
          if (!link) return;
          const href = link.getAttribute("href");
          if (!href) return;
          e.preventDefault();
          const productInfo = link.closest("product-info");
          const modal = productInfo?.querySelector(".licence-modal");
          openModal(modal, href);
        });

        document.addEventListener("click", (e) => {
          if (!e.target.closest("[data-licence-modal-close]")) return;
          e.preventDefault();
          closeModal();
        });

        document.addEventListener("keydown", (e) => {
          if (e.key !== "Escape") return;
          const openModalEl = document.querySelector(
            ".licence-modal:not([hidden])",
          );
          if (openModalEl) closeModal(openModalEl);
        });
      }

      /**
       * Initializes .download-item[data-download="true"] links to force
       * download (blob) instead of opening in the browser.
       * Runs on connect and after each HTML update (variant change).
       */
      initDownloadItems() {
        const container = this.isConnected ? this : document;
        const downloadItems = container.querySelectorAll?.(
          ".download-item[data-download='true']",
        );
        if (!downloadItems?.length) return;

        const getFilenameFromUrl = (url) => {
          try {
            const cleanUrl = url.split("?")[0];
            const urlPath = cleanUrl.split("/");
            const filename = urlPath[urlPath.length - 1];
            return decodeURIComponent(filename);
          } catch (e) {
            return "download";
          }
        };
        const hasExtension = (filename) =>
          /\.[a-zA-Z0-9]+$/.test(filename);

        downloadItems.forEach((link) => {
          if (link.dataset.downloadInitialized) return;
          link.dataset.downloadInitialized = "true";

          link.addEventListener("click", function (e) {
            e.preventDefault();
            let url = this.href;
            let filename = this.dataset.filename || "";
            if (url.startsWith("//")) {
              url = "https:" + url;
            } else if (!url.startsWith("http")) {
              url = "https://" + url;
            }
            if (!filename || !hasExtension(filename)) {
              filename = getFilenameFromUrl(url);
            }
            this.style.opacity = "0.5";
            this.style.pointerEvents = "none";
            const self = this;

            const xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
              if (xhr.status === 200) {
                const blob = xhr.response;
                if (window.navigator?.msSaveBlob) {
                  window.navigator.msSaveBlob(blob, filename);
                  self.style.opacity = "1";
                  self.style.pointerEvents = "auto";
                  return;
                }
                const blobUrl = window.URL.createObjectURL(blob);
                const tempLink = document.createElement("a");
                tempLink.href = blobUrl;
                tempLink.download = filename;
                tempLink.style.display = "none";
                document.body.appendChild(tempLink);
                tempLink.click();
                setTimeout(() => {
                  document.body.removeChild(tempLink);
                  window.URL.revokeObjectURL(blobUrl);
                  self.style.opacity = "1";
                  self.style.pointerEvents = "auto";
                }, 100);
              } else {
                self.style.opacity = "1";
                self.style.pointerEvents = "auto";
                window.open(url, "_blank");
              }
            };
            xhr.onerror = function () {
              self.style.opacity = "1";
              self.style.pointerEvents = "auto";
              window.open(url, "_blank");
            };
            xhr.send();
          });
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initPdpDynamicPrice() {
        const blocks = this.querySelectorAll("[data-pdp-dynamic-price-block]");
        blocks.forEach((wrap) => {
          if (wrap.hasAttribute("data-pdp-price-bound")) return;
          const blockId = wrap.getAttribute("data-pdp-dynamic-price-block");
          const sectionId = wrap.getAttribute("data-section-id");
          if (!sectionId || !blockId) return;
          const totalEl = document.getElementById(
            `PDPDynamicTotal-${sectionId}-${blockId}`,
          );
          const originalEl = document.getElementById(
            `PDPDynamicOriginal-${sectionId}-${blockId}`,
          );
          if (!totalEl) return;

          wrap.setAttribute("data-pdp-price-bound", "1");
          applyPdpDynamicUnitPrice(wrap, totalEl, originalEl);
        });
      }

      initVolumeDiscountsLinkDiscountKitSync() {
        if (!this.querySelector(".volume-discounts-wrapper")) {
          if (this.volumeDiscountsKitObserver) {
            this.volumeDiscountsKitObserver.disconnect();
            this.volumeDiscountsKitObserver = null;
          }
          return;
        }

        const sync = () => {
          const wrappers = this.querySelectorAll(".volume-discounts-wrapper");
          if (!wrappers.length) return;
          const dk = findDiscountKitVolumeTable(this);
          const visible = isDkVolumeTableElementVisible(dk, this);
          wrappers.forEach((w) =>
            w.classList.toggle("volume-discounts-wrapper--dk-hidden", !visible),
          );
        };

        const schedule = () => {
          if (this.volumeDiscountsLinkSyncTimer)
            clearTimeout(this.volumeDiscountsLinkSyncTimer);
          this.volumeDiscountsLinkSyncTimer = setTimeout(() => {
            this.volumeDiscountsLinkSyncTimer = null;
            sync();
          }, 80);
        };

        if (this.volumeDiscountsKitObserver) {
          this.volumeDiscountsKitObserver.disconnect();
        }
        this.volumeDiscountsKitObserver = new MutationObserver(() =>
          schedule(),
        );
        this.volumeDiscountsKitObserver.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class", "hidden"],
        });

        if (!this.volumeDiscountsKitVariantUnsubscriber) {
          this.volumeDiscountsKitVariantUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            ({ data }) => {
              if (data?.sectionId !== this.sectionId) return;
              schedule();
            },
          );
        }

        sync();
        requestAnimationFrame(() => schedule());
      }

      updatePdpPriceOnVariantChange({ data }) {
        if (!data || data.sectionId !== this.sectionId || !data.variant) return;
        const variant = data.variant;
        const variantPrice = variant.price != null ? variant.price : 0;
        const variantId = variant.id != null ? String(variant.id) : "";
        const compareAt =
          variant.compare_at_price != null ? variant.compare_at_price : 0;
        const blocks = this.querySelectorAll("[data-pdp-dynamic-price-block]");
        blocks.forEach((wrap) => {
          wrap.setAttribute("data-unit-price", String(variantPrice));
          wrap.setAttribute("data-variant-id", variantId);
          wrap.setAttribute("data-compare-at-price", String(compareAt));
          const blockId = wrap.getAttribute("data-pdp-dynamic-price-block");
          const blockSectionId = wrap.getAttribute("data-section-id");
          if (!blockSectionId || !blockId) return;
          const totalEl = document.getElementById(
            `PDPDynamicTotal-${blockSectionId}-${blockId}`,
          );
          const originalEl = document.getElementById(
            `PDPDynamicOriginal-${blockSectionId}-${blockId}`,
          );
          if (!totalEl) return;
          applyPdpDynamicUnitPrice(wrap, totalEl, originalEl);
        });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = undefined;

        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.pdpVariantChangeUnsubscriber?.();
        this.volumeDiscountsKitVariantUnsubscriber?.();
        this.volumeDiscountsKitVariantUnsubscriber = undefined;
        if (this.volumeDiscountsKitObserver) {
          this.volumeDiscountsKitObserver.disconnect();
          this.volumeDiscountsKitObserver = null;
        }
        if (this.volumeDiscountsLinkSyncTimer) {
          clearTimeout(this.volumeDiscountsLinkSyncTimer);
          this.volumeDiscountsLinkSyncTimer = null;
        }
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel"),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          this.initDownloadItems();
          this.initPdpDynamicPrice();
          this.initVolumeDiscountsLinkDiscountKitSync();
          if (typeof window.initBuyNowButtons === "function") {
            window.initBuyNowButtons(newNode);
          }
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").textContent =
              html.querySelector("head title").textContent;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]",
        )?.textContent;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`,
            );
            if (source && destination) {
              destination.replaceChildren(
                ...Array.from(source.childNodes, (n) => n.cloneNode(true)),
              );
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === "",
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden"),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
          );

          // Update Buy Now button state (do not interrupt in-flight checkout)
          const buyNowButton = document.querySelector(
            `#buy-now-form-${this.sectionId} button[type="submit"]`,
          );
          const productSubmitButton = html.getElementById(
            `ProductSubmitButton-${this.sectionId}`,
          );
          if (
            buyNowButton &&
            productSubmitButton &&
            !isBuyNowButtonInFlight(buyNowButton)
          ) {
            if (productSubmitButton.hasAttribute("disabled")) {
              buyNowButton.setAttribute("disabled", "disabled");
              const buttonText =
                productSubmitButton.querySelector("span")?.textContent ||
                window.variantStrings.soldOut;
              buyNowButton.textContent = buttonText;
            } else {
              buyNowButton.removeAttribute("disabled");
              buyNowButton.textContent = "Buy Now";
            }
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        // Update Buy Now form variant ID
        const buyNowForm = document.querySelector(
          `#buy-now-form-${this.sectionId}`,
        );
        if (buyNowForm) {
          const buyNowInput = buyNowForm.querySelector('input[name="id"]');
          if (buyNowInput) {
            buyNowInput.value = variantId ?? "";
          }
        }
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`,
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`,
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable,
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        // Update product-media (Swiper-based gallery)
        const productMedia = this.querySelector("product-media");
        if (productMedia && typeof productMedia.setActiveMedia === "function") {
          productMedia.setActiveMedia(variantFeaturedMediaId);
        }

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]"),
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.replaceChildren(
            ...Array.from(newModalContent.childNodes, (n) => n.cloneNode(true)),
          );
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        const spinner = this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        );
        if (spinner) spinner.classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            const spinnerEnd = this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            );
            if (spinnerEnd) spinnerEnd.classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.replaceChildren(
              ...Array.from(updated.childNodes, (n) => n.cloneNode(true)),
            );
            if (selector === ".quantity__label") {
              const updatedAriaLabelledBy =
                updated.getAttribute("aria-labelledby");
              if (updatedAriaLabelledBy) {
                current.setAttribute("aria-labelledby", updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent =
                    updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products",
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list",
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}
